import { render } from "./WorkspaceIcon.vue?vue&type=template&id=59dae15d&scoped=true&bindings={\"image\":\"props\",\"size\":\"props\",\"backgroundImageStyle\":\"options\"}"
import script from "./WorkspaceIcon.vue?vue&type=script&lang=js"
export * from "./WorkspaceIcon.vue?vue&type=script&lang=js"

import "./WorkspaceIcon.vue?vue&type=style&index=0&id=59dae15d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-59dae15d"

export default script